/**
 * DOM Mutation Resilience Utility
 *
 * Protects React DOM reconciliation from crashing when browser extensions
 * (translators, password managers, grammarly, etc.) or external head/body
 * injections mutate the DOM by safeguarding Node.prototype.removeChild
 * and Node.prototype.insertBefore.
 */
if (typeof window !== 'undefined' && typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChildResilient(child) {
    if (child && child.parentNode !== this) {
      if (process.env.NODE_ENV !== 'production' && console && typeof console.warn === 'function') {
        console.warn('[DOM Resilience] Prevented removeChild error: Node is not a direct child of parent.', child, this);
      }
      if (child.parentNode) {
        return child.parentNode.removeChild(child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBeforeResilient(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (process.env.NODE_ENV !== 'production' && console && typeof console.warn === 'function') {
        console.warn('[DOM Resilience] Prevented insertBefore error: Reference node is not a direct child of parent.', referenceNode, this);
      }
      if (referenceNode.parentNode) {
        return referenceNode.parentNode.insertBefore(newNode, referenceNode);
      }
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

export default true;
